const ComponentContainer = (props) => {
    return (
        <div className="px-4 md:px-12 lg:px-44 xl:px-56">
            {props.children}
        </div>
    )
}

export default ComponentContainer;